var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPhotoAlternateWhite24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.737,
    height: 29.147,
    viewBox: "0 0 31.737 29.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M0 0h31.737v29.147H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47",
    d: "M23.158 24.075H4.645v-17h11.9V4.643h-11.9A2.551 2.551 0 0 0 2 7.072v17A2.551 2.551 0 0 0 4.645 26.5h18.513a2.551 2.551 0 0 0 2.642-2.425v-10.93h-2.642zm-10.3-3.85-2.592-2.866-3.638 4.287h14.547l-4.681-5.72zM25.8 4.643V1h-2.642v3.643h-3.967c.013.012 0 2.429 0 2.429h3.967V10.7c.013.012 2.645 0 2.645 0V7.072h3.967V4.643z",
    transform: "translate(.644 .214)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoAlternateWhite24Dp);
export default __webpack_public_path__ + "static/media/add_photo_alternate_white_24dp.3cdca9991e7e3ed41dcc4316192dd13d.svg";
export { ForwardRef as ReactComponent };